export interface GetIsMenuReadyArgs {
  hasBuyerMarketplaceId: boolean
  hasConnectedBuyerMembership: boolean
  hasSeller: boolean
  isBuyer: boolean
  isSeller: boolean
}

export const getIsMenuReady = ({
  hasBuyerMarketplaceId,
  hasConnectedBuyerMembership,
  hasSeller,
  isBuyer,
  isSeller,
}: GetIsMenuReadyArgs) => {
  const isBuyerSectionReady = isBuyer ? hasBuyerMarketplaceId : true

  const isSellerSectionReady = isSeller ? hasSeller : true

  const isConnectedBuyerSectionReady = hasConnectedBuyerMembership ? hasBuyerMarketplaceId : true

  const isMenuReady = isBuyerSectionReady && isSellerSectionReady && isConnectedBuyerSectionReady

  return isMenuReady
}
